import { apiFetch } from '@/platform/lib/api';

export type BlogPost = {
  id: string;
  authorId: string;
  title: string;
  body: string;
  slug: string;
  status: 'draft' | 'published';
  publishedAt?: string;
  createdAt: string;
  updatedAt: string;
};

export type BlogListResponse = {
  posts: BlogPost[];
  nextCursor?: string;
};

export function listBlogPosts(params?: { limit?: number; cursor?: string }) {
  const q = new URLSearchParams();
  if (params?.limit) q.set('limit', String(params.limit));
  if (params?.cursor) q.set('cursor', params.cursor);
  const qs = q.toString();
  return apiFetch<BlogListResponse>(`/blog${qs ? `?${qs}` : ''}`);
}

export function listMyBlogPosts(params?: { status?: 'draft' | 'published' | 'all'; limit?: number }) {
  const q = new URLSearchParams();
  if (params?.status) q.set('status', params.status);
  if (params?.limit) q.set('limit', String(params.limit));
  const qs = q.toString();
  return apiFetch<BlogListResponse>(`/blog/posts/mine${qs ? `?${qs}` : ''}`);
}

export function getBlogPostBySlug(slug: string) {
  return apiFetch<BlogPost>(`/blog/${slug}`);
}

export function getBlogPostById(id: string) {
  return apiFetch<BlogPost>(`/blog/posts/${id}`);
}

export function createBlogPost(input: {
  title: string;
  body: string;
  slug?: string;
  status?: 'draft' | 'published';
}) {
  return apiFetch<BlogPost>('/blog/posts', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export function updateBlogPost(
  id: string,
  input: Partial<{ title: string; body: string; slug: string; status: 'draft' | 'published' }>,
) {
  return apiFetch<BlogPost>(`/blog/posts/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(input),
  });
}

export function deleteBlogPost(id: string) {
  return apiFetch<{ status: string }>(`/blog/posts/${id}`, {
    method: 'DELETE',
  });
}

export function setBlogPostEmoji(postId: string, emoji: string) {
  return apiFetch<{ emoji: string }>(`/blog/posts/${postId}/emoji`, {
    method: 'POST',
    body: JSON.stringify({ emoji }),
  });
}

export function getBlogPostEmoji(postId: string) {
  return apiFetch<{ emoji: string }>(`/blog/posts/${postId}/emoji`);
}
